import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=7ff64b93&scoped=true"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProfileSidebar.vue?vue&type=style&index=0&id=7ff64b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff64b93",
  null
  
)

export default component.exports